<template>
  <div class="footer">
    <div class="content view view-slideup on">
      <div class="footer-row">
        <div class="col col1">
          <i class="foot-icon foot-icon1"></i>
          <div class="foot-info">
            <h5 style="cursor: pointer" onclick="psp1lAow(); return false">
              <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.contactus') }}</font></font>
            </h5>

            <p>
              <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.Strive') }}</font></font>
            </p>
            <p class="txt2" @click="$parent.openKefu">
              <a href="javascript:void(0);"
                ><font style="vertical-align: inherit"><font style="vertical-align: inherit"></font></font></a
              >
              <!-- <a href="javascript:;" id="dedicated-manager-normal-1"
                ><font style="vertical-align: inherit"><font style="vertical-align: inherit">tg@tgames.vip</font></font></a
              > -->
                <a href="javascript:;" id="dedicated-manager-normal-1"
                ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.contactus') }}</font></font></a
              >
            </p>
          </div>
        </div>
        <div class="col col2">
          <i class="foot-icon foot-icon2"></i>
          <div class="foot-info">
            <h5 style="cursor: pointer" onclick="toEditDocDetails(51295)">
              <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.hAgentome') }}</font></font>
            </h5>
            <p>
              <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.Let') }}</font></font>
            </p>
            <p class="txt2" @click="$parent.openKefu">
              <a href="javascript:void(0);"
                ><font style="vertical-align: inherit"><font style="vertical-align: inherit"></font></font></a
              >
              <a href="javascript:;" id="dedicated-manager-normal-1"
                ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.Join') }}</font></font></a
              >
            </p>
          </div>
        </div>
        <div class="col col3">
          <i class="foot-icon foot-icon3"></i>
          <div class="foot-info">
            <h5>
              <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.security') }}</font></font>
            </h5>
            <p>
              <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$store.state.appInfo.title}}</font></font>
            </p>
            <p class="txt2">
              <a href="javascript:void(0);"
                ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.Professional') }}</font></font></a
              >
            </p>
          </div>
        </div>
        <div class="col col4">
          <i class="foot-icon foot-icon4"></i>
          <div class="foot-info">
            <h5>
              <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.Gaming') }}</font></font>
            </h5>
            <p>
              <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.Hold') }}</font></font>
            </p>
            <p class="txt2 pz" style="position: relative">
              <a href="javascript:void(0);"
                ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.View') }} &gt;</font></font></a
              >
            </p>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="sponsors"></div>
      <div class="foot-nav">
        <ul>
          <li>
            <a @click="$parent.goNav('/footAll?type=0')"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.about') }}</font></font></a
            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">| </font></font>
          </li>
          <li>
            <a @click="$parent.goNav('/footAll?type=1')"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.contact') }}</font></font></a
            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">| </font></font>
          </li>
          <li>
            <a @click="$parent.goNav('/footAll?type=2')"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.Agents') }}</font></font></a
            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">| </font></font>
          </li>
          <li>
            <a @click="$parent.goNav('/footAll?type=3')"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.Disclaimer') }}</font></font></a
            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">| </font></font>
          </li>
          <li>
            <a @click="$parent.goNav('/footAll?type=4')"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.Privacy') }}</font></font></a
            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">| </font></font>
          </li>
          <li>
            <a @click="$parent.goNav('/footAll?type=5')"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.common') }}</font></font></a
            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">| </font></font>
          </li>
          <li>
            <a @click="$parent.goNav('/footAll?type=6')"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('foot.game') }}</font></font></a
            >
          </li>
        </ul>
        <div class="clear"></div>
        <div class="copyright all-rights">

          <font style="vertical-align: inherit"><font style="vertical-align: inherit">© 2022 {{$store.state.appInfo.title}} {{ $t('foot.All') }}. </font></font>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//
export default {
  name: 'Foot',
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
// @import '../../../static/css/chunk-611499bd.2ebefcf0.css';
</style>



// WEBPACK FOOTER //
// src/components/libs/Foot.vue